import React from 'react';
import { ArrowUp } from 'lucide-react';
import { Container } from '@/components/layout/Container';

export const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-bg-secondary border-t border-border-subtle">
      <Container>
        <div className="py-12 md:py-16">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Logo & Copyright */}
            <div className="flex flex-col items-center md:items-start gap-2">
              <a href="/" className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-apple-blue flex items-center justify-center">
                  <span className="text-white font-bold text-sm">CTL</span>
                </div>
                <span className="text-body font-semibold text-text-primary">
                  Larsen<span className="text-apple-blue">.md</span>
                </span>
              </a>
              <p className="text-caption text-text-tertiary">
                &copy; {currentYear} Christer Torgilstveit Larsen, MD. All rights reserved.
              </p>
            </div>

            {/* Legal Links */}
            <div className="flex items-center gap-6">
              <a href="/privacy" className="text-caption text-text-tertiary hover:text-text-secondary transition-colors">
                Privacy Policy
              </a>
              <span className="w-1 h-1 rounded-full bg-text-tertiary" />
              <a href="/terms" className="text-caption text-text-tertiary hover:text-text-secondary transition-colors">
                Terms of Use
              </a>
              <span className="w-1 h-1 rounded-full bg-text-tertiary" />
              <a href="/contact" className="text-caption text-text-tertiary hover:text-text-secondary transition-colors">
                Contact
              </a>
            </div>

            {/* Back to Top */}
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 text-caption text-text-tertiary hover:text-apple-blue transition-colors"
              aria-label="Back to top"
            >
              <span>Back to top</span>
              <ArrowUp className="w-4 h-4" />
            </button>
          </div>

          {/* Professional Notice */}
          <div className="mt-8 pt-8 border-t border-border-subtle">
            <p className="text-caption text-text-tertiary text-center max-w-3xl mx-auto">
              This website is for professional advisory inquiries only. No personal medical 
              consultations are provided through this platform. Bound by Norwegian medical 
              professional standards and strict confidentiality protocols.
            </p>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
